import { registerComponent } from '@gig/magic-common';
import KeycloakLoginExpiredComponent from './keycloak-login-expired.vue.js';

var KeycloakLoginExpired = registerComponent(KeycloakLoginExpiredComponent);

export { KeycloakLoginExpired };
